var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M2.5 7.16875V3.5C2.5 3.36739 2.55268 3.24021 2.64645 3.14645C2.74021 3.05268 2.86739 3 3 3H13C13.1326 3 13.2598 3.05268 13.3536 3.14645C13.4473 3.24021 13.5 3.36739 13.5 3.5V7.16875C13.5 12.4187 9.04375 14.1562 8.15625 14.45C8.05543 14.4873 7.94457 14.4873 7.84375 14.45C6.95625 14.1562 2.5 12.4187 2.5 7.16875Z",
    fill: "#6C7689"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 3.625V7.16875C3.125 11.9011 7.06636 13.5257 8 13.8432C8.93363 13.5257 12.875 11.9011 12.875 7.16875V3.625H3.125ZM2.2045 2.7045C2.41548 2.49353 2.70163 2.375 3 2.375H13C13.2984 2.375 13.5845 2.49353 13.7955 2.7045C14.0065 2.91548 14.125 3.20163 14.125 3.5V7.16875C14.125 12.8479 9.30275 14.7272 8.36107 15.0405C8.12756 15.1238 7.87244 15.1238 7.63893 15.0405C6.69725 14.7272 1.875 12.8479 1.875 7.16875V3.5C1.875 3.20163 1.99353 2.91548 2.2045 2.7045Z",
    fill: "#6C7689"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2022 6.06858C11.4405 6.31834 11.4312 6.71395 11.1814 6.95222L7.51267 10.4522C7.27104 10.6827 6.89088 10.6826 6.64945 10.4519L4.8182 8.70185C4.56865 8.46337 4.55967 8.06775 4.79815 7.8182C5.03663 7.56865 5.43225 7.55967 5.68181 7.79815L7.08162 9.13586L10.3186 6.04778C10.5683 5.80952 10.964 5.81883 11.2022 6.06858Z",
    fill: "#6C7689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.279626a3daf29b90ae7f252517685a2b.svg";
export { ForwardRef as ReactComponent };